import axios, { AxiosError } from "axios";
import { LocaleService } from "./storage.service";
import baseModule, { SnackBarColor } from "@/store/base.module";
import { blobToJson } from "@/utils";
import { BaseResponseData } from "./api/types";
import authModule from "@/store/auth.module";

export const setApiServiceLocale = () => {
  axios.defaults.headers.common["Accept-Language"] = LocaleService.getLocale();
};

setApiServiceLocale();
axios.interceptors.request.use((config) => {
  config.params = {
    ...(baseModule.blockRECAPTCHA ? { ignoreCaptcha: true } : {}),
    ...config.params,
  };

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const getDataMessage = async (error: AxiosError<any>) => {
      if (error.request.responseType == "blob")
        return (await blobToJson<BaseResponseData>(error.response?.data))
          ?.message;
      return error.response?.data.message;
    };

    let message = "serverErrorMessage";
    let color: SnackBarColor = "error";

    const res = error.response;

    if (res) {
      switch (res.status) {
        case 400:
          // eslint-disable-next-line no-case-declarations
          const dataMessage = await getDataMessage(error);
          if (dataMessage) {
            message = dataMessage;
            color = "warning";
          }
          break;
        case 401:
          authModule.redirectToWSOLoginPage();
          return;
        case 405: //recaptcha fail
          message = "Повторите еще раз";
          color = "warning";
          if (res.config && res.config.data) {
            try {
              //v3
              if (JSON.parse(res.config.data).action) {
                baseModule.setRecaptchaFailDate();
              }
            } catch (e) {
              console.error(e);
            }
          }

          break;
        case 500:
          console.error(await getDataMessage(error));
          message = await getDataMessage(error);
          break;
      }
    } else if (error.message) {
      message = error.message;
    }
    baseModule.showMessage({ message, color });
    return Promise.reject(error);
  }
);

export default axios;
